/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type LangInput = "de" | "en" | "es" | "fr" | "it";
export type OfferType = "buy" | "rent";
export type PropertyMainType = "AGRI" | "APPT" | "BUILDING" | "COMMERCIAL" | "GARDEN" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "INDUS" | "OTHER" | "PARK" | "PROP" | "ROOM" | "SECONDARY";
export type PropertySearchNotification = "daily" | "never" | "weekly";
export type PropertyStatus = "existing" | "new";
export type PropertyUsage = "investment" | "primary" | "secondary";
export type TypeOfPlace = "agglomeration" | "country" | "district" | "locality" | "municipality" | "neighbourhood" | "postcode" | "region" | "state";
export type UpsertPropertySearchInput = {|
  propertySearch?: ?PropertySearchInput,
  anonymousUserEmailAddress?: ?string,
  clientMutationId?: ?string,
|};
export type PropertySearchInput = {|
  id?: ?string,
  userId?: ?string,
  places?: ?$ReadOnlyArray<string>,
  propertyTypes?: ?$ReadOnlyArray<string>,
  offerType?: ?OfferType,
  propertyUsage?: ?PropertyUsage,
  propertyStatuses?: ?$ReadOnlyArray<PropertyStatus>,
  propertyMainTypeIn?: ?$ReadOnlyArray<PropertyMainType>,
  propertyMainTypeNotIn?: ?$ReadOnlyArray<PropertyMainType>,
  notification?: ?PropertySearchNotification,
  initCreatedAtGte?: ?boolean,
  activateAggregator?: ?boolean,
  comment?: ?string,
  salePriceGte?: ?number,
  salePriceLte?: ?number,
  monthlyRentGte?: ?number,
  monthlyRentLte?: ?number,
  livingSurfaceGte?: ?number,
  livingSurfaceLte?: ?number,
  builtSurfaceGte?: ?number,
  builtSurfaceLte?: ?number,
  landSurfaceGte?: ?number,
  landSurfaceLte?: ?number,
  balconySurfaceGte?: ?number,
  gardenSurfaceGte?: ?number,
  financingPassportGte?: ?number,
  financingPassportLte?: ?number,
  numberOfRoomsGte?: ?number,
  numberOfRoomsLte?: ?number,
  numberOfBathroomsGte?: ?number,
  numberOfBathroomsLte?: ?number,
  numberOfBedroomsGte?: ?number,
  numberOfBedroomsLte?: ?number,
  numberOfIndoorParkingsGte?: ?number,
  numberOfOutdoorParkingsGte?: ?number,
  hasBalcony?: ?boolean,
  hasGarden?: ?boolean,
  hasParking?: ?boolean,
  hasLift?: ?boolean,
  hasView?: ?boolean,
  hasFireplace?: ?boolean,
  hasGarage?: ?boolean,
  isChildFriendly?: ?boolean,
  isMinergieCertified?: ?boolean,
  isNewDevelopment?: ?boolean,
  isFurnished?: ?boolean,
  isWheelchairAccessible?: ?boolean,
  hasSwimmingPool?: ?boolean,
  salePricePerLivingSurfaceGte?: ?number,
  salePricePerLivingSurfaceLte?: ?number,
  filters?: ?AggregatesListingFiltersInput,
  source?: ?string,
  aggregatorSource?: ?string,
|};
export type AggregatesListingFiltersInput = {|
  bounds?: ?InputGeoBounds,
  placesById?: ?$ReadOnlyArray<?PlaceInput>,
  placeSlugs?: ?$ReadOnlyArray<?PlaceSlugInput>,
  offerType_eq: OfferType,
  createdAt_gte?: ?string,
  salePrice_lte?: ?number,
  salePrice_gte?: ?number,
  grossRentMonthly_lte?: ?number,
  grossRentMonthly_gte?: ?number,
  grossRentM2yearly_lte?: ?number,
  grossRentM2yearly_gte?: ?number,
  grossRentRoomMonthly_lte?: ?number,
  grossRentRoomMonthly_gte?: ?number,
  salePricePerLivingSurface_lte?: ?number,
  salePricePerLivingSurface_gte?: ?number,
  salePricePerLandSurface_lte?: ?number,
  salePricePerLandSurface_gte?: ?number,
  numberOfRooms_lte?: ?number,
  numberOfRooms_gte?: ?number,
  livingSurface_lte?: ?number,
  livingSurface_gte?: ?number,
  landSurface_lte?: ?number,
  landSurface_gte?: ?number,
  compositePropertyType_eq?: ?CompositePropertyType,
  portal_in?: ?$ReadOnlyArray<?string>,
  agencyReference_contains?: ?string,
  agencyNames?: ?string,
  hasBalcony_eq?: ?boolean,
  hasGarden_eq?: ?boolean,
  hasParking_eq?: ?boolean,
  hasElevator_eq?: ?boolean,
  hasView_eq?: ?boolean,
  hasFireplace_eq?: ?boolean,
  hasGarage_eq?: ?boolean,
  isChildFriendly_eq?: ?boolean,
  isWheelchairAccessible_eq?: ?boolean,
  isMinergieCertified_eq?: ?boolean,
  isNewDevelopment_eq?: ?boolean,
  isFurnished_eq?: ?boolean,
  bookOnline_eq?: ?boolean,
  isFsbo_eq?: ?boolean,
  clusterIds_contains?: ?number,
  id_eq?: ?string,
  id_in?: ?$ReadOnlyArray<string>,
|};
export type InputGeoBounds = {|
  north: number,
  south: number,
  east: number,
  west: number,
|};
export type PlaceInput = {|
  type: TypeOfPlace,
  objectId: string,
|};
export type PlaceSlugInput = {|
  lang: LangInput,
  slug: string,
|};
export type AggregatesListingCreateSearchMutationVariables = {|
  input: UpsertPropertySearchInput
|};
export type AggregatesListingCreateSearchMutationResponse = {|
  +upsertPropertySearch: ?{|
    +propertySearch: ?{|
      +id: string
    |}
  |}
|};
export type AggregatesListingCreateSearchMutation = {|
  variables: AggregatesListingCreateSearchMutationVariables,
  response: AggregatesListingCreateSearchMutationResponse,
|};
*/


/*
mutation AggregatesListingCreateSearchMutation(
  $input: UpsertPropertySearchInput!
) {
  upsertPropertySearch(input: $input) {
    propertySearch {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertPropertySearchPayload",
    "kind": "LinkedField",
    "name": "upsertPropertySearch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PropertySearch",
        "kind": "LinkedField",
        "name": "propertySearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingCreateSearchMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AggregatesListingCreateSearchMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e306415935211cfc3d1708c3dc6a376e",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingCreateSearchMutation",
    "operationKind": "mutation",
    "text": "mutation AggregatesListingCreateSearchMutation(\n  $input: UpsertPropertySearchInput!\n) {\n  upsertPropertySearch(input: $input) {\n    propertySearch {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3e61996c2f5e226d8fb387c80f405e5e';

export default node;
